import * as mutations from './mutations';
import * as queries from './queries';

export * from './ApolloClient';

export { mutations };
export { queries };
